module.exports = __webpack_public_path__ + "img/6.fb20ea33.svg";